import React from "react";
import logo from "../../resources/images/malslogo.png";
import "./Navigation.scss";

function Nav() {
  return (
    <nav className="header">
      <img src={logo} alt="Logo" className="logo" />
    </nav>
  );
}

export default Nav;
